// Slick slider
import 'slick-carousel';

$(document).ready(function () {
    $('.single-item').slick({
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        pauseOnHover: false
    });

    $('.fabric').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        pauseOnHover: false,
        asNavFor: '.fabricnav'
    });
    $('.fabricnav').slick({
        slidesToShow: 15,
        slidesToScroll: 1,
        asNavFor: '.fabric',
        dots: false,
        centerMode: true,
        pauseOnHover: false,
        focusOnSelect: true
    });
    $('.headerslider').slick({
        autoplay: true,
        dots: false,
        arrows: false,
        fade: true,
        pauseOnHover: false
    });
    const impressionCarousel = $('.impression-carousel').slick({
        slidesToShow: 2,
        infinite: false,
        responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
              }
            },
        ],
        nextArrow: document.querySelector('.impression-carousel__arrow--next'),
        prevArrow: document.querySelector('.impression-carousel__arrow--prev')
    });
    if(impressionCarousel.length >= 1) {
        const totalItems = impressionCarousel[0].slick.slideCount
        const statusbar = document.querySelector('.impression-carousel__progress_bar');
        const statusbarWidth = 100 / totalItems * 2

        statusbar.style.width = statusbarWidth+'%';

        impressionCarousel.on('afterChange', function(event, slick, currentSlide, nextSlide){
            const offset = 100 / (totalItems / currentSlide)
            statusbar.style.left = offset+'%';           
        });
    }
});
